module.exports = __webpack_public_path__ + "static/michael_bryant-32b7348a208aeaba64a3852ca01be027.png";